import { render } from "./articleDetails.vue?vue&type=template&id=2580fdfe&scoped=true"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"

import "./articleDetails.vue?vue&type=style&index=0&id=2580fdfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2580fdfe"]])

export default __exports__